export const data = {
  "Work Law": {
    paragraphs: [
      "worklaw.p1",
      "worklaw.p2",
      "worklaw.p3",
      "worklaw.p4",
      "worklaw.p5",
      "worklaw.p6",
      "worklaw.p7",
      "worklaw.p8"
    ],
  },
  "Immigration Law": {
    paragraphs: [
      "immigration.p1",
      "immigration.p2",
      "immigration.p3",
      "immigration.p4",
      "immigration.p5",
      "immigration.p6",
      "immigration.p7",
      "immigration.p8",
      "immigration.p9",
      "immigration.p10"
    ],
  },
  "Traffic Code": {
    paragraphs: [
      "trafficcode.p1",
      "trafficcode.p2",
      "trafficcode.p3",
      "trafficcode.p4",
      "trafficcode.p5",
      "trafficcode.p6",
      "trafficcode.p7",
      "trafficcode.p8"
    ],
  },
  "Workers right": {
    paragraphs: [
      "workersright.p1",
      "workersright.p2",
      "workersright.p3",
      "workersright.p4",
      "workersright.p5",
      "workersright.p6",
      "workersright.p7",
      "workersright.p8",
      "workersright.p9"
    ],
  },
  "Substance Abuse": {
    paragraphs: [
      "substanceabuse.p1",
      "substanceabuse.p2",
      "substanceabuse.p3",
      "substanceabuse.p4",
      "substanceabuse.p5"
    ],
  },
  "Child and parenting laws in the U.S.": {
    paragraphs: [
      "childparenting.p1",
      "childparenting.p2",
      "childparenting.p3",
      "childparenting.p4",
      "childparenting.p5",
      "childparenting.p6",
      "childparenting.p7"
    ],
  },
  "Healthcare Law": {
    paragraphs: [
      "healthcarelaw.p1",
      "healthcarelaw.p2",
      "healthcarelaw.p3",
      "healthcarelaw.p4",
      "healthcarelaw.p5"
    ],
  },
  "Family Roles": {
    paragraphs: [
      "familyroles.p1",
      "familyroles.p2",
      "familyroles.p3",
      "familyroles.p4",
      "familyroles.p5"
    ],
  },
  "Hunting Laws": {
    paragraphs: [
      "huntinglaws.p1",
      "huntinglaws.p2",
      "huntinglaws.p3"
    ],
  },
  "Privacy and Data Protection Law": {
    paragraphs: [
      "privacyprotection.p1",
      "privacyprotection.p2",
      "privacyprotection.p3",
      "privacyprotection.p4",
      "privacyprotection.p5",
      "privacyprotection.p6"
    ],
  }
};
